/**
 * Fonts loaded at runtime on web: none.
 *
 * The web template declares all nine `Inter-*` families as `@font-face` rules over
 * self-hosted variable woff2 files, so the browser owns font loading entirely and there is
 * nothing for `expo-font` to fetch. An empty map also means the root layout's font gate is
 * satisfied on the first render, because `useFonts` seeds its state from whether every key
 * is already loaded and a map with no keys trivially is.
 *
 * This exists as a platform file rather than a branch inside the shared module so the nine
 * `.ttf` imports stay out of the web bundle. A runtime `isWeb` ternary still pulls them
 * into the graph, and Metro emits all nine — roughly 2.7 MB of typefaces that no web page
 * can reach, since no rule references them.
 *
 * Splitting the file is only half of that, and the other half is easy to undo by accident:
 * the Google Fonts package's entry point requires all nine typefaces at module scope, so
 * importing anything at all from it — `useFonts` included — drags them back in. The root
 * layout therefore takes that hook from `expo-font` directly, and this package must stay
 * imported from the native file alone.
 */
export const FONTS = {};
